import styled from 'styled-components';

export default styled.input.attrs({ type: 'radio' })`
  margin-right: 15px;
`;
